import { DownOutlined } from "@ant-design/icons";
import { Button, Modal } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import download from "../../../src/assets/Icons/downloadIconPermission.svg";
import zoom from "../../../src/assets/Icons/zoomBtn.svg";
import BarChartSkeleton from "../../Reuseable/Skeleton/BarchartSkeleton";
import StackedBarChart from "../../Reuseable/StackedBar/StackedBarChart";
import Tabs from "../../Reuseable/Tabs/Tabs"; // Import the Tabs component
import ActionHeader from "../../Reuseable/actionHeader/ActionHeader";
import ChartFilterModal from "../../Reuseable/actionHeader/ChartFilter";
import PermissionComp from "../../components/PermissionComp/PermissionComp";
import { fetchDRRTable, fetchPerformance } from "../../store/performance";
import { drrProductivityData } from "../ProductivityPage/productivityData";
import ActionCodes from "./ActionCodesComp/ActionCodes";
import "./NewPerformancePage.scss"; // Import CSS for styling
import PerformanceDonutCard from "./PerformanceDonutCard/PerformanceDonutCard";
import ExcelDownloader from "../../assets/helpers/excelDownload";
import { fetchCaseDetails } from "../../store/productivity";

const NewPerformancePage = () => {
  const [primaryItems, setPrimaryItems] = useState([]);
  const [secondaryItems, setSecondaryItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [showPermissionModal, setShowPermissionModal] = useState(false);
  const [selectedTab, setSelectedTab] = useState("Intensity");
  const [selectTab, setSelectTab] = useState("1M");

  const [selectedCategory, setSelectedCategory] = useState("team_member");
  const [pagination, setPagination] = useState({
    page: 1,
    page_size: 10,
    next: null,
    previous: null,
  });
  const [selectedTrustMap, setSelectedTrustMap] = useState({
    team_member: [],
    team_leader: [],
  });
  const [refresh, setRefresh] = useState(false);

  // ✅ selectors AFTER states
  const { filter_list } = useSelector((state) => state?.filters);
  const { performance, drr_table, drr_loading, loading } = useSelector(
    (state) => state.performance
  );
  const { caseDetails, caseDetailsLoading } = useSelector(
    (state) => state.productivity
  );

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchPerformance({ selectedCategory, ...selectedTrustMap }));

    dispatch(
      fetchCaseDetails({ selectedCategory, ...selectedTrustMap, ...pagination })
    );
  }, [dispatch, refresh]);

  const handlePagination = (paginationInfo) => {
    setPagination({
      ...pagination,
      page: paginationInfo.current,
      page_size: paginationInfo.pageSize,
    });

    dispatch(
      fetchCaseDetails({
        selectedCategory,
        ...selectedTrustMap,
        page: paginationInfo.current,
        page_size: paginationInfo.pageSize,
      })
    );

    dispatch(
      fetchDRRTable({
        selectedCategory,
        ...selectedTrustMap,
        page: paginationInfo.current,
        page_size: paginationInfo.pageSize,
      })
    );
  };

  return (
    <div className="new-performance-container">
      <ActionHeader
        heading="Performance"
        primaryItems={primaryItems}
        secondaryItems={secondaryItems}
        setPrimaryItems={setPrimaryItems}
        showSecondaryItems={true}
        setSecondaryItems={setSecondaryItems}
        fetchData={fetchPerformance}
        fetchData2={fetchDRRTable}
        setRefresh={setRefresh}
      />
      <div className="performance-tabs">
        <Tabs
          options={[
            { label: "Intensity", value: "Intensity" },
            { label: "Productivity", value: "Productivity" },
          ]}
          height="40px"
          active={selectedTab}
          onChange={setSelectedTab}
          showSelector="true"
          classname="active-inactive-tab"
          selectorBreakpoint={200}
        />

        <Button
          style={{ height: "35px", fontWeight: 500 }}
          onClick={() => setOpen(true)}
        >
          Filter <DownOutlined />
        </Button>
      </div>

      {selectedTab === "Intensity" && (
        <div className="intensityGraph">
          <div className="graphWrapper">
            <div className="titleForGraph">
              <h2>Intensity</h2>
              <div className="graphBox">
                <div className="sectOne">
                  <h2 className="header">Avg Intensity</h2>
                  <p className="bold">
                    {performance?.overall_intensity_metrics?.avg_intensity ||
                      "--"}
                  </p>
                </div>
                {/* <div className="sectTwo">
                  <PerformanceDonutCard />
                </div> */}
                <div className="sectThree">
                  <h2 className="header">Total No. Cases</h2>
                  <p className="bold">
                    {performance?.overall_intensity_metrics?.total_cases ||
                      "--"}
                  </p>
                </div>
              </div>
            </div>
            {loading ? (
              <BarChartSkeleton />
            ) : (
              <StackedBarChart
                title="Intensity"
                data={performance?.entity_performance_breakdown?.map(
                  (item) => ({
                    name: item?.name,
                    total_cases: item?.total_cases,
                  })
                )}
                keys={["total_cases"]}
                tooltipType={"attempts"}
                colors={["#00B247"]}
                keysVisible={false}
                chartName="Cases"
                yLabel=""
                gridOptions={{
                  left: "0",
                  right: "0%",
                  bottom: "8%",
                  top: "10%",
                  stroke: "#E6E6E6",
                  strokeDasharray: "0",
                  vertical: false,
                }}
                height={240}
                margin={{ top: 0, right: 0, bottom: 1, left: 0 }}
                rotate={true}
                slice={true}
                Intensity={true}
              />
            )}
          </div>
          <div className="actionCodesGraph">
            {/* <div className="title_with_arrow">
            <p className="casesTitle">No. of Cases</p>
            <img src={arrrowIcon} alt="" />
          </div> */}
            <div className="graph_container">
              {loading ? (
                <BarChartSkeleton />
              ) : (
                <ActionCodes data={performance} />
              )}
            </div>
          </div>
        </div>
      )}

      {selectedTab === "Productivity" && (
        <div className="productivityContainer">
          <h2>Productivity</h2>
          <div className="graphTableWrapper">
            <div className="drrGraph">
              <div className="headerSection">
                <h2>DRR</h2>
                <div className="durationTabs">
                  <Tabs
                    options={[
                      { label: "1M", value: "1M" },
                      { label: "3M", value: "3M" },
                      { label: "6M", value: "6M" },
                      { label: "1Y", value: "1Y" },
                    ]}
                    active={selectTab} // ✅ set active
                    onChange={setSelectTab} // ✅ handle change
                    classname="active-inactive-tab"
                    height="40px"
                  />
                </div>
              </div>
              <div className="graph_box">
                {loading ? (
                  <BarChartSkeleton />
                ) : (
                  <StackedBarChart
                    title="Positive"
                    data={drrProductivityData?.chart}
                    keys={drrProductivityData?.keys}
                    tooltipType={"attempts"}
                    colors={drrProductivityData?.colors}
                    keysVisible={false}
                    chartName="Cases"
                    yLabel=""
                    gridOptions={{
                      left: "0",
                      right: "0%",
                      bottom: "5%",
                      top: "10%",
                      stroke: "#E6E6E6",
                      strokeDasharray: "0",
                      vertical: false,
                    }}
                    height={370}
                    margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
                  />
                )}
              </div>
            </div>
            <div className="tableSection">
              <div className="table_header">
                <ExcelDownloader
                  data={caseDetails?.results}
                  fileName="drr_file"
                />
                <img
                  src={zoom}
                  alt="Zoom"
                  onClick={() => setShowPermissionModal(true)}
                  style={{ cursor: "pointer" }}
                />
              </div>
              <div className="table">
                <PermissionComp
                  handlePagination={handlePagination}
                  data={caseDetails?.results}
                  loading={caseDetailsLoading}
                  pagination={pagination}
                  setPagination={setPagination}
                />
              </div>
            </div>
          </div>
        </div>
      )}

      <Modal
        open={showPermissionModal}
        onCancel={() => setShowPermissionModal(false)}
        footer={null}
        title="Permissions Overview"
        width="90%"
        style={{ top: 20, height: "90vh" }}
        bodyStyle={{ maxHeight: "90vh", overflowY: "auto" }}
        className="permissionModal"
      >
        <PermissionComp
          handlePagination={handlePagination}
          data={caseDetails?.results}
          loading={caseDetailsLoading}
          pagination={pagination}
          setPagination={setPagination}
        />
      </Modal>

      <ChartFilterModal
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory}
        open={open}
        setOpen={setOpen}
        setSecondaryItems={setSecondaryItems}
        selectedTrustMap={selectedTrustMap}
        setSelectedTrustMap={setSelectedTrustMap}
        setRefresh={setRefresh}
      />
    </div>
  );
};

export default NewPerformancePage;
